<template>
  <div class="ui-pop" v-show="info.show">
    <div class="ui-mask"></div>
    <div class="ui-modal large scroll">
      <p class="modal-title">{{ $t('title') }}</p>
      <a class="modal-close" @click="info.show = false"
        ><i class="el-icon-close"></i
      ></a>
      <div class="content">
        <div class="courseInfo">
          <div class="avatar">
            <img
              :src="info.data.teacherUserPicUrl"
              alt=""
              style="object-fit: cover"
            />
          </div>
          <div>
            <p class="name">{{ info.data.teacherName }}</p>
            <!-- <p><span class="lab">科目：</span><span>English Literature</span></p> -->
            <p>
              <span class="lab">{{ $t('form.course') }}：</span
              ><span>{{ info.data.courseName }}</span>
            </p>
            <p>
              <span class="lab">{{ $t('date') }}：</span
              ><span>{{ getTime(info.data) }}</span>
            </p>
          </div>
        </div>
        <div class="comment">
          <div class="row">
            <span class="lab">{{ $t('comment1') }}:</span>
            <el-rate
              v-model="info.data.commentStar1"
              :disabled="info.data.isComment !== 0"
              void-icon-class="voidrate"
              :icon-classes="['rated', 'rated', 'rated']"
            ></el-rate>
          </div>
          <div class="row">
            <span class="lab">{{ $t('comment2') }}:</span>
            <el-rate
              v-model="info.data.commentStar2"
              :disabled="info.data.isComment !== 0"
              void-icon-class="voidrate"
              :icon-classes="['rated', 'rated', 'rated']"
            ></el-rate>
          </div>
          <div class="row">
            <span class="lab">{{ $t('comment3') }}:</span>
            <el-rate
              v-model="info.data.commentStar3"
              :disabled="info.data.isComment !== 0"
              void-icon-class="voidrate"
              :icon-classes="['rated', 'rated', 'rated']"
            ></el-rate>
          </div>
          <div class="row">
            <span class="lab">{{ $t('comment4') }}:</span>
            <el-rate
              v-model="info.data.commentStar4"
              :disabled="info.data.isComment !== 0"
              void-icon-class="voidrate"
              :icon-classes="['rated', 'rated', 'rated']"
            ></el-rate>
          </div>
          <div class="row">
            <span class="lab">{{ $t('comment5') }}:</span>
            <el-rate
              v-model="info.data.commentStar5"
              :disabled="info.data.isComment !== 0"
              void-icon-class="voidrate"
              :icon-classes="['rated', 'rated', 'rated']"
            ></el-rate>
          </div>
        </div>
        <div class="btns">
          <a class="ui-btn gray" @click="info.show = false">{{
            $t('cancel')
          }}</a>
          <a class="ui-btn" @click="commentCourse">{{ $t('common.submit') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commentCourse } from '@/service/studentApi.js'
import moment from 'moment'
export default {
  props: ['info'],
  data() {
    return {}
  },
  methods: {
    getTime(obj) {
      return (
        moment(obj.beginTime * 1000).format('DD/MM/YYYY HH:mm —— ') +
        moment(obj.endTime * 1000).format('HH:mm')
      )
    },
    async commentCourse() {
      const res = await commentCourse(this.info.data)
      if (res.data.status === 1) {
        this.$message({ type: 'success', message: this.$t('common.commentsuccess') })
        this.info.show = false
        this.info.data.isComment = 1
      }
    },
  },
  mounted() {},
}
</script>
<style lang="scss" scoped>
.content {
  padding: 70px 130px;
}
.courseInfo {
  display: flex;
  padding: 0 20px 70px;
  border-bottom: 1px solid #ececec;
  .avatar {
    width: 160px;
    height: 160px;
    overflow: hidden;
    font-size: 0;
    margin-right: 50px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  p {
    margin-top: 15px;
color: #555;
    font-size: 18px;
    line-height: 1;
  }
  .name {
    font-size: 32px;
    color: #002248;
    margin: 18px 0;
  }
  .lab {
    color: #000;
  }
}
.comment {
  padding: 60px;
}
.row {
  margin-bottom: 20px;
  display: flex;
  .lab {
    min-width: 55%;
    text-align: right;
    margin-right: 18px;
  }
}
</style>
<i18n>
{
  "cn": {
    "title": "课后评价表",
    "date": "上课日期",
    "comment1":"达成学习目标",
    "comment2":"学术专长",
    "comment3":"教学清晰度",
    "comment4":"平易近人和相处融洽",
    "comment5":"灵感和动力"
  },
  "TW": {
    "title": "課後評價表",
    "date": "上課日期",
    "comment1":"達成學習目標",
    "comment2":"學術專長",
    "comment3":"教學清晰度",
    "comment4":"平易近人和相處融洽",
    "comment5":"靈感和動力"
  },
  "en": {
    "title": "Lesson Evaluation",
    "date": "Lesson date and time",
    "comment1":"Achieving Learning Objectives",
    "comment2":"Academic Expertise",
    "comment3":"Clarity of Teaching",
    "comment4":"Approachability and Rapport",
    "comment5":"Inspiration and Motivation"
  }
}
</i18n>